export interface LoadDTO {
  id: number;
  plate_number: string;
  delivery_time: string;
  quantity: number;
  provider_delivery_note: string;
}

export interface LoadDTOAmount {
  id: number;
  plate_number: string;
  delivery_time: string;
  amount: number;
  provider_delivery_note: string;
}

class TransitDataDTO {
  code: string;
  loads: LoadDTO[];
  provider_id: number;

  constructor({ code, loads, provider_id }) {
    this.code = code;
    this.loads = loads;
    this.provider_id = provider_id;
  }
}
export default TransitDataDTO;
